import React, { createContext, useState } from "react";

export const SignInContext = createContext(null);

export const SignInProvider = ({ children }) => {
	const [signedIn, setSignedIn] = useState(false);
	const [googleProfile, setGoogleProfile] = useState({});

	return (
		<SignInContext.Provider
			value={{ signedIn, setSignedIn, googleProfile, setGoogleProfile }}
		>
			{children}
		</SignInContext.Provider>
	);
};
